import React from "react";
import { useSelector } from "react-redux";
import ModalComponent from "../../ModalComponent/ModalComponent";

const ToggleModalComponent = () => {
  const ComponentProp = useSelector((store) => store?.ComponentPropReducer);
  console.log(ComponentProp, "ComponentProp");
  return (
    <>
      {ComponentProp &&
        ComponentProp.length > 0 &&
        ComponentProp?.map((e, i) => <ModalComponent key={i} Tablekey={e.Table_Key} prop={e.props} />)}
    </>
  );
};

export default ToggleModalComponent;
